import {useLocation} from 'react-router-dom';
import ClientShell from '@/pages/ClientShell';
import ClientErrorBoundary from '@/components/ClientErrorBoundary';

// A notification can switch Studio without leaving /client. Clear the old
// relationship and form state before loading the destination from its URL.
export default function ClientRoute() {
  const {search}=useLocation();
  return <ClientErrorBoundary key={search} search={search}><ClientShell/></ClientErrorBoundary>;
}
